import type { ComponentPropsWithoutRef } from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

/**
 * Canonical home / marketing section title. One size at each breakpoint so
 * chapters read as a system and stay smaller than the page hero.
 */
export const sectionHeadingVariants = cva(
  'text-3xl font-extrabold leading-[1.15] tracking-tight md:text-4xl',
  {
    variants: {
      tone: {
        default: 'text-oxford-blue',
        inverse: 'text-white',
      },
    },
    defaultVariants: {
      tone: 'default',
    },
  },
);

export interface SectionHeadingProps
  extends ComponentPropsWithoutRef<'h2'>, VariantProps<typeof sectionHeadingVariants> {
  as?: 'h2' | 'h3';
}

export function SectionHeading({
  as: Comp = 'h2',
  className,
  tone,
  ...props
}: SectionHeadingProps) {
  return <Comp className={cn(sectionHeadingVariants({ tone }), className)} {...props} />;
}
